import script from "./EditCategoryForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCategoryForm.vue?vue&type=script&setup=true&lang=js"

import "./EditCategoryForm.vue?vue&type=style&index=0&id=6a53db62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a53db62"]])

export default __exports__